var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex align-center"},[_c('icon',{staticClass:"has-text-grey tooltip",attrs:{"icon":"thermometer-quarter","data-tooltip":`The device's temperature as at ${_vm.reading.read_at}`}}),_vm._v(" "+_vm._s(_vm.value)+" °C ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }